export const getInitialState = (): any => ({
  previewData: {},
  previewStatus: 0
});
